import React from 'react';

import {
	ApSecondaryNav,
	ApButtonTab,
	ApMenu,
	ApMenuItem,
	colors,
} from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';

export const NAV_CONFIG = [
	{
		name: 'spend',
		label: 'Deep Dive',
		child: [
			{
				path: '/spend',
				name: 'spend',
				label: 'Investigate',
			},
			{
				path: '/spend/benchmarks',
				name: 'benchmarks',
				label: 'Benchmarks',
			},
			{
				path: '/spend/explore',
				name: 'transactions',
				label: 'Transactions',
			},
			{
				path: '/spend/pivot-table',
				name: 'pivot-table',
				label: 'Pivot Table',
			},
		],
	},
	{
		name: 'suplier-diversity-program',
		label: 'Supplier Diversity Program',
		path: '/spend/suplier-diversity-program', // include path key when you don't want to group navigation
		child: [
			{
				path: '/spend/suplier-diversity-program',
				name: 'suplier-diversity-program',
				label: 'Supplier Diversity Program',
			},
		],
	},
	{
		name: 'apvendor-library',
		label: 'AP Vendor Library',
		path: '/spend/apvendor-library',
		child: [
			{
				path: '/spend/apvendor-library',
				name: 'apvendor-library',
				label: 'AP Vendor Library',
			},
		],
	},
];

export const SecondaryNav = ({ companies, disabledCompany }) => {
	const location = useLocation();

	return (
		<ApSecondaryNav
			left={NAV_CONFIG.map(tab => {
				if ('path' in tab) {
					const { label, path } = tab;
					return (
						<NavLink to={path} key={path}>
							<ApButtonTab isSelected={location.pathname.includes(path)}>
								{label}
							</ApButtonTab>
						</NavLink>
					);
				} else {
					return (
						<ApMenu
							toggleVariant="hover"
							button={
								<ApButtonTab
									isSelected={tab.child.some(
										child => child.path === location.pathname
									)}
								>
									{tab.label}
								</ApButtonTab>
							}
						>
							{tab.child.map(option => (
								<ApMenuItem
									key={option.value}
									style={{
										backgroundColor:
											option.path === location.pathname ? colors.green0 : null,
									}}
								>
									<NavLink
										to={option.path}
										key={option.path}
										disabled={option.disabled}
									>
										{option.label}
									</NavLink>
								</ApMenuItem>
							))}
						</ApMenu>
					);
				}
			})}
		/>
	);
};

export default SecondaryNav;
